import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CustomSelectComponent } from '@core/components/custom-select/custom-select.component';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { SharedModule } from '@shared/shared.module';
import { AddPaymentPage } from './add-payment/payment.page';
import { authGuard } from './auth.guard';
import { ForgotPasswordPage } from './forgot-password/forgot-password.page';
import { InscriptionsPaymentsComponent } from './inscription-payments/inscriptions-payments.component';
import { LoginPage } from './login/login.page';
import { PaymentPage } from './payment/payment.page';
import { RegisterFormPage } from './register-form/register-form';
import { RegisterPage } from './register/register';
import { LevelBadgeComponent } from '@core/components/level-badge/level-badge.component';

@NgModule({
  declarations: [
    LoginPage,
    ForgotPasswordPage,
    RegisterPage,
    RegisterFormPage,
    PaymentPage,
    AddPaymentPage,
    InscriptionsPaymentsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    TranslocoModule,
    SharedModule,
    CustomSelectComponent,
    LevelBadgeComponent,
    RouterModule.forChild([
      {
        path: 'login',
        component: LoginPage,
      },
      {
        path: 'register',
        component: RegisterPage,
        canActivate: [authGuard],
      },
      {
        path: 'register/form',
        component: RegisterFormPage,
      },
      {
        path: 'payment',
        component: PaymentPage,
      },
      {
        path: 'add-payment',
        component: AddPaymentPage,
      },
      {
        path: 'forgot',
        component: ForgotPasswordPage,
      },
    ]),
  ],
  exports: [
    LoginPage,
    ForgotPasswordPage,
    RegisterPage,
    RegisterFormPage,
    PaymentPage,
    AddPaymentPage,
    InscriptionsPaymentsComponent,
  ],
})
export class OnboardingModule {}
